export const privacyPolicyData = {
  introduction: {
    title: "Privacy Policy",
    subtitle: "We Value Your Privacy",
    description: "Konstant Online Privacy Policy Statement Highlights",
    introText:
      "Protecting personal information is a responsibility that we take very seriously, and we also expect the same from you. Konstant Infosolutions is committed to transparency and choice regarding protecting the privacy of our client’ s personal information as well as that of all visitors to our website.",
    policyText:
      'This privacy policy outlines what data Konstant Infosolutions Pvt. Ltd. (herein referred to as "Konstant", "Konstantinfo", "We", "Our", or "Us") collects, stores, and processes about you. It also explains your rights to your data and how you can contact us if you have any questions. We reserve the right to alter this privacy statement at our discretion and encourage you to check this section from time to time to be aware of any changes.',
  },
  sections: [
    {
      title: "To whom this policy applies",
      content:
        'This privacy statement applies to individuals ("users" or "you") who interact with our website, subscribe to any of our products, request information, or use the chat support (herein collectively referred to as "services").',
    },
    {
      title: "How we collect data",
      content:
        "<span>Depending on services you use, we collect data from one or more of these three sources:</span>",
      subsections: [
        {
          title: "1. Data we request:",
          intro:
            "When you request any of our services, we may ask, store, and process any/all of these data categories:",
          bullets: [
            "Your Name",
            "Your Country",
            "Your Email Id",
            "Your MS Teams Id",
            "Your Phone Number",
            "Other information that you choose to share",
          ],
        },
        {
          title: "2. Cookies:",
          intro:
            "<span>Cookies are small files placed on your computer when you first visit our website that helps analyze web traffic and tracks you across the web. The collection of this data is based on “implied consent”, i.e we assume you agree to our terms of usage unless you explicitly opt out. You can opt out by changing your browser settings to not accept cookies, browsing in anonymous mode, or by not using our website.<br/><br/>We also have on our website links to many third-party services and use third-party tools, the privacy policy of which may be different from us and we assume no responsibility for their compliance. The third-party tools we use cookies to collect data are:</span>",
          content:
            "<ol><li><strong>Google Analytics</strong> - It collects data related to the device/browser, IP address and on-site activities to measure and report statistics about your interactions on the web. It is used to enhance user experience and we do not access your personally identifiable information. To understand how Google Analytics handles your data, read their privacy policy.</li><li><strong>Intercom</strong> - We use Intercom to provide customer support on our website. While they don’t have access to private data you share with our representatives, they may collect additional data that is enforced by their privacy policy.</li><li><strong>Lucky Orange</strong> - We use Lucky Orange to anonymously track usage of our website including your clicks, cursor hoovers, scroll depth, and more. We may also record some sessions anonymously to track your behavior across our platform to help improve the user experience. Read Lucky Orange's privacy policy.</li></ol>",
        },
        {
          title: "3. External tools:",
          intro:
            "<span>We also use some tools to collect data about your usage and behavior beyond our website that include:</span>",
          content:
            "<ol><li><strong>MailChimp</strong> - Promotional emails we send are tracked to know much traffic they bring on our website. We may also track if an individual email is opened by any recipient to calculate click rates and improve engagement. We use MailChimp as our email marketing tool and they are governed by their own privacy policy.</li><li><strong>Social plugins</strong> - We have on our website links to many social media platforms for more engagement and visibility. Once you click on any of those links to visit any of those platforms, they collect, use, and share your data as per their own privacy policies, of which we assume no responsibility. We encourage you to check out the privacy policies of the social platform we use: Facebook, X, LinkedIn, YouTube, Behance, Dribble.</li></ol>",
        },
      ],
    },
    {
      title: "Why we collect these data",
      intro:
        "The data we collect from these cookies can be personally identifiable or anonymous. We collect this data to:",
      bullets: [
        "Offer personalized service",
        "Create a secure platform",
        "Improve performance",
        "Statistical analysis",
      ],
    },
    {
      title: "How we secure your data",
      content:
        "The security of your personal data is of utmost importance to us and we take all appropriate measures to protect it. There are requisite technical, administrative, and physical barriers in place to ensure your data is accessible only to authorized persons or systems. In case we discover a data breach, we immediately (within 72 hours) inform the local authorities and affected users.",
    },
    {
      title: "How we use your personal data",
      intro:
        "We store and process the data we collect for our legitimate interests and service delivery fully under the ambit of law. We use your data:",
      bullets: [
        "To provide and maintain our services.",
        "To improve our services and website experience.",
        "To communicate with you via email, notification, or any other contact information that you have provided.",
        "To provide any third-party requisite data that helps enable our services.",
        "For internal research and management.",
        "For fraud detection.",
        "To enforce our terms and conditions.",
      ],
    },
    {
      title: "When we share your personal data",
      content:
        "We do not share your personal data with any third-party whatsoever except in cases where:",
    },
    {
      title: "How do we protect your information?",
      intro:
        "We have strict security procedures covering the storage of your information in order to prevent unauthorized access . This means that sometimes we may ask you for proof of identity or for other personal information before we can process your call or enquiry further",
      bullets: [
        "Your explicit consent is obtained.",
        "Mandated by law.",
        "Third-party is a collaborator or a part (subsidiary, parent/sister company) of Konstant.",
        "To provide any third-party requisite data that helps enable our services.",
      ],
    },
    {
      title: "What you can do",
      intro:
        "You have full control over what information we store and its subsequent usage. You can choose to:",
      bullets: [
        "Unsubscribe from the mailing list and notification preferences to stop receiving such communication.",
        "You can choose to not share your information by not filling up the form and not using the chat support.",
        "You can at any time change your consent earlier provided for any specific use of your data.",
        "If you have any question regarding our privacy policy or data handling practices, we would be glad to hear from you at mail@Konstantinfo.com",
      ],
    },
  ],
};
